import React, { ReactElement } from 'react';
import classNames from 'classnames';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Button, EButtonType, KitIcons } from '@repo/apg-ui';
import styles from '../../../components/CampaignRow/CampaignRow.module.scss';
import SpinnerV2 from '../../../components/SpinnerV2';
import { Campaigns } from './Dashboard';
import { ReactComponent as RightArrow } from '../../../assets/icons/arrow_right.svg';
import { format, isValid } from 'date-fns';
import { de } from 'date-fns/locale';
import Tooltip from 'rc-tooltip';

interface Props {
  intl: any;
  data: any;
  journey3: boolean;
  history: any;
  currentlyVisible: number;
  isLoading: boolean;
  onLoadMore: any;
  header: ReactElement;
  onDeleteClick: any;
}

const OffersTable = ({
  journey3,
  history,
  currentlyVisible,
  data,
  isLoading,
  onLoadMore,
  header,
  intl,
  onDeleteClick,
}: Props) => {
  return (
    <div className='pageContainerTwo'>
      <div className='row'>
        <div
          className={classNames('col-12 d-flex justify-content-between', {
            'flex-column': journey3,
          })}
        >
          <h4 className='font-weight-bold mb-3 mt-4'>{header}</h4>
        </div>

        <div className='col-12 pb-4'>
          <div className='d-flex flex-column mt-48'>
            <div className={`d-flex table-header ${styles.productTitle}`}>
              <div className={styles.productRowCampaignColumn}>
                <p className='font-weight-bold'>
                  <FormattedMessage id='ec.confirmation.table.offertenumber' defaultMessage='Offert-Nr.' />
                </p>
              </div>

              <div className={styles.productRowCampaignColumn}>
                <p className='font-weight-bold'>
                  <FormattedMessage id='ec.confirmation.table.kunde' defaultMessage='Kunde' />
                </p>
              </div>

              <div className={styles.productRowCampaignColumn}>
                <p className='font-weight-bold'>
                  <FormattedMessage id='ec.confirmation.table.sujet' defaultMessage='Sujet' />
                </p>
              </div>

              <div className={styles.productRowCampaignColumn}>
                <p className='font-weight-bold'>
                  <FormattedMessage id='ec.confirmation.table.period' defaultMessage='Zeitraum' />
                </p>
              </div>

              <div className={styles.productRowCampaignColumn}>
                <p className='font-weight-bold'>
                  <FormattedMessage id='ec.confirmation.table.advertisingForm' defaultMessage='Werbeform' />
                </p>
              </div>

              <div className={classNames(styles.productRowCampaignColumn, 'nonJ3')}>
                <div className='d-flex flex-column'>
                  <p className='font-weight-bold'>
                    <FormattedMessage id='ec.confirmation.table.mediacount' defaultMessage='Anzahl Flächen' />
                  </p>
                </div>
              </div>

              <div className={classNames(styles.productRowCampaignColumn, 'nonJ3')}>
                <p className='font-weight-bold'>
                  <FormattedMessage id='ec.confirmation.table.mediaprice' defaultMessage='Total Kosten in CHF' />
                </p>
              </div>

              <div className={classNames(styles.productRowCampaignColumn, 'nonJ3')}>
                <p className='font-weight-bold'>
                  <FormattedMessage id='ec.confirmation.table.statusvalidtil' defaultMessage='Status / Gültig bis' />
                </p>
              </div>

              <div className={classNames(styles.productRowCampaignColumn, styles.flexRow)} />
            </div>
            {data &&
              data.length > 0 &&
              data.map((campaign: any, index) => {
                if (index < currentlyVisible) {
                  return (
                    <div className={styles.productCampaignRow}>
                      <div className={classNames(styles.productRowCampaignColumn)}>{campaign.number}</div>

                      <div className={styles.productRowCampaignColumn}>{campaign.customer}</div>
                      <div className={styles.productRowCampaignColumn}>{campaign.name}</div>

                      <div className={styles.productRowCampaignColumn}>
                        <FormattedMessage id='ec.campaignRow.Ab' defaultMessage='Ab' />{' '}
                        {isValid(Date.parse(campaign.startdate))
                          ? format(Date.parse(campaign.startdate), 'dd-MM-yyyy', { locale: de })
                          : campaign.startdate}
                      </div>

                      <div className={styles.productRowCampaignColumn}>{campaign.formats}</div>

                      <div className={classNames(styles.productRowCampaignColumn, 'nonJ3')}>
                        <div className='d-flex flex-row'>{campaign.mediacount}</div>
                      </div>

                      <div className={classNames(styles.productRowCampaignColumn, 'nonJ3')}>
                        <div className='d-flex flex-row'>{campaign.mediaprice}</div>
                      </div>

                      <div className={classNames(styles.productRowCampaignColumn, 'nonJ3')}>
                        <div className='d-flex flex-row'>{campaign.statelabel}</div>
                      </div>
                      <div className={classNames(styles.productRowCampaignColumn, styles.flexRow)}>
                        <Tooltip
                          overlayClassName={'rc-tooltip-bg-white'}
                          placement={'right'}
                          overlay={
                            <b>
                              <FormattedMessage id='ec.confirmation.removeBasket.legend' defaultMessage='Löschen' />
                            </b>
                          }
                        >
                          <div
                            className={styles.removeButton}
                            onClick={() => onDeleteClick(campaign.basket, campaign.customer, campaign.number)}
                          >
                            <KitIcons.TrashIcon />
                          </div>
                        </Tooltip>
                        <Tooltip
                          overlayClassName={'rc-tooltip-bg-white'}
                          placement={'right'}
                          overlay={
                            <b>
                              <FormattedMessage
                                id='ec.components.buttons.journey03.openCampaignTooltip'
                                defaultMessage='Detail'
                              />
                            </b>
                          }
                        >
                          <Button to={`/offerte/${campaign.number}`}>
                            <RightArrow />
                          </Button>
                        </Tooltip>
                      </div>
                    </div>
                  );
                }

                return null;
              })}

            {!isLoading ? (
              <>
                {currentlyVisible !== data.length && data.length > Campaigns.SHOW_WITHOUT_BTN && (
                  <>
                    <div className='my-24 mx-auto'>
                      <Button className='ml-4 add-to-cart' buttonType={EButtonType.PillMedium} onClick={onLoadMore}>
                        <FormattedMessage
                          id='ec.components.buttons.mehrLoden'
                          defaultMessage='Weitere Kampagnen anzeigen'
                        />
                      </Button>
                    </div>
                  </>
                )}
              </>
            ) : (
              <SpinnerV2 relative />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default injectIntl(OffersTable);
